<script lang='ts'>
  import Instructions from "./Instructions.svelte"
  import Puzzle from "./Puzzle.svelte"
  import { IPuzzle, get_puzzle, puzzles } from './puzzles'
  import { 
    load_completed_puzzles, load_current_puzzle, 
    load_revealed_words, load_turn_is_guess, save_current_puzzle, 
    save_revealed_words, save_turn_is_guess, todays_puzzle 
  } from './state'
  import Stats from "./Stats.svelte"

  // state
  let completed_puzzles = load_completed_puzzles()
  let revealed_words = load_revealed_words()
  let turn_is_guess = load_turn_is_guess()
  let current_puzzle = load_current_puzzle()

  let puzzle = get_puzzle(current_puzzle)
  let current_page = already_completed(puzzle.name) ? 'change' : 'guess'
  let available_puzzles = puzzles.slice(0, todays_puzzle+1)

  let show_intro = true


function change_puzzle(new_puzzle:IPuzzle, index: number) {
  puzzle = new_puzzle
  revealed_words = []
  turn_is_guess = false
  current_page = 'guess'
  save_current_puzzle(index)
  save_revealed_words(revealed_words)
  save_turn_is_guess(turn_is_guess)
}
function already_completed(puzzle:string):boolean {
  return completed_puzzles.some(el => el.title === puzzle)
}
//@ts-ignore
window.change_puzzle = function (index) {
  change_puzzle(puzzles[index], index)
}

//TODO refactor for readability - both components are long and hard to follow
//TODO roadblock if someone clears all the words without guessing the answer.
</script>
{#if current_page === 'change'}
{#if completed_puzzles.length > 0}
<div style='margin-bottom: .75rem;'><button on:click={()=>{current_page = 'stats'}}>Show Stats</button></div>
{/if}
{#each available_puzzles as puzzle_title, index}
<button
  on:click={()=>{change_puzzle(available_puzzles[available_puzzles.length - index - 1], available_puzzles.length - index - 1)}}
  disabled={already_completed(available_puzzles[available_puzzles.length - index - 1].name)}
>
  {available_puzzles.length - index}
</button>
{/each}
{:else if current_page === 'stats'}
<Stats {completed_puzzles} bind:current_page={current_page}/>
{:else}
  <button on:click={()=>{current_page = 'change'}}>Change Puzzle</button>
  {#if completed_puzzles.length > 0}
    <button on:click={()=>{current_page = 'stats'}}>Show Stats</button>
  {/if}
  <Puzzle
    {puzzle}
    {revealed_words}
    {turn_is_guess}
    bind:completed_puzzles={completed_puzzles}
  />
{/if}
{#if !localStorage.getItem('is_subsequent_visit') && show_intro}
  <Instructions bind:show_intro={show_intro}/>
{/if}